module.exports = __webpack_public_path__ + "static/img/shop-add.8d531ba1.png";